<template>
  <div v-bem>
    <div v-bem:badge="{ [`acc-${color}`]: color !== null }" />
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Indicator',
  props: {
    color: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use 'sass:map';

.indicator {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @at-root #{&}__badge {
    display: block;
    position: absolute;
    z-index: 1;
    top: utils.f-rem-calc(-1);
    right: utils.f-rem-calc(-3);
    width: utils.f-rem-calc(8);
    height: utils.f-convert-to-rem(8);
    border-radius: 50%;
    background-color: currentColor;

    @each $key, $color in utils.$v-colors {
      @at-root #{&}--#{$key} {
        background-color: $color;
      }
    }
  }
}
</style>
